<template>
  <path
    d="M12 2.00018C6.48 2.00018 2 6.48018 2 12.0002C2 17.5202 6.48 22.0002 12 22.0002C17.52 22.0002 22 17.5202 22 12.0002C22 6.48018 17.52 2.00018 12 2.00018ZM4 12.0002C4 7.58018 7.58 4.00018 12 4.00018C13.85 4.00018 15.55 4.63018 16.9 5.69018L5.69 16.9002C4.63 15.5502 4 13.8502 4 12.0002ZM12 20.0002C10.15 20.0002 8.45 19.3702 7.1 18.3102L18.31 7.10018C19.37 8.45018 20 10.1502 20 12.0002C20 16.4202 16.42 20.0002 12 20.0002Z"
  />
</template>
